import { DUPE_API_URL } from '@dupe/common/constants'
import { useQuery } from '@tanstack/react-query'
import useAuthUser from '~/src/hooks/useAuthUser'
import fetcher from '~/src/lib/fetcher'

interface ValidateInviteResponse {
  inviteCode: string
  valid: boolean
  reason?: string
}

/**
 * Hook to validate an invite code and get inviter details (authenticated)
 */
export const useValidateInvite = (code: string | null) => {
  const { authUser } = useAuthUser()

  return useQuery<ValidateInviteResponse>({
    queryKey: ['validate-invite', code],
    queryFn: async () => {
      if (!code) {
        throw new Error('No invite code provided')
      }

      const data = await fetcher<ValidateInviteResponse>(
        `${DUPE_API_URL}/api/user/validate-invite/${encodeURIComponent(code)}`,
        {
          method: 'GET',
          authUser,
        }
      )
      return data
    },
    enabled: !!code && !!authUser,
  })
}
